import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orderbook-aggregation" }

import { isMobile } from 'mobile-device-detect';
import { computed, ref, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';

import { AggregationOperation } from '@exchange/libs/orderbook/service/src';

enum HoverType {
  hoverPlus = 'hoverPlus',
  hoverMinus = 'hoverMinus',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderbookAggregation',
  props: {
  reducePossible: {
    type: Boolean,
    required: true,
  },
  raisePossible: {
    type: Boolean,
    required: true,
  },
  level: {
    type: [Number, String],
    required: true,
  },
  mini: {
    type: Boolean,
    default: false,
  },
},
  emits: ["aggregate"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const hoverPlus = ref(false);
const hoverMinus = ref(false);

const toggle = (hoverType: HoverType) => {
  if (!isMobile) {
    return;
  }

  switch (hoverType) {
    case HoverType.hoverPlus:
      hoverPlus.value = !hoverPlus.value;
      break;
    case HoverType.hoverMinus:
      hoverMinus.value = !hoverMinus.value;
      break;
    default:
      break;
  }
};

const aggregationValue = computed(() => {
  if (Number.isNaN(Number(props.level))) {
    return t('modules.orderbook.none');
  }

  return props.level;
});
const hoverPlusTimeout = ref();
const hoverMinusTimeout = ref();

const reduceAggregation = () => {
  if (props.reducePossible) {
    toggle(HoverType.hoverMinus);
    emit('aggregate', AggregationOperation.REDUCE);

    hoverMinusTimeout.value = setTimeout(() => toggle(HoverType.hoverMinus), 500);
  }
};
const raiseAggregation = () => {
  if (props.raisePossible) {
    toggle(HoverType.hoverPlus);
    emit('aggregate', AggregationOperation.RAISE);

    hoverPlusTimeout.value = setTimeout(() => toggle(HoverType.hoverPlus), 500);
  }
};

onBeforeUnmount(() => {
  if (hoverPlusTimeout.value) {
    clearTimeout(hoverPlusTimeout.value);
  }

  if (hoverMinusTimeout.value) {
    clearTimeout(hoverMinusTimeout.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["orderbook-aggregation__button", { 'orderbook-aggregation__button--disabled': !__props.raisePossible }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (raiseAggregation()), ["stop"]))
    }, [
      _createVNode(_component_ot_icon, { name: "add-square" })
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["orderbook-aggregation__value", { 'orderbook-aggregation__value--mini': __props.mini }])
    }, _toDisplayString(aggregationValue.value), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["orderbook-aggregation__button", { 'orderbook-aggregation__button--disabled': !__props.reducePossible }]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (reduceAggregation()), ["stop"]))
    }, [
      _createVNode(_component_ot_icon, { name: "minus-square" })
    ], 2)
  ]))
}
}

})